import { render, staticRenderFns } from "./CurrencyEdit.vue?vue&type=template&id=5487981b"
import script from "./CurrencyEdit.vue?vue&type=script&lang=ts"
export * from "./CurrencyEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5487981b')) {
      api.createRecord('5487981b', component.options)
    } else {
      api.reload('5487981b', component.options)
    }
    module.hot.accept("./CurrencyEdit.vue?vue&type=template&id=5487981b", function () {
      api.rerender('5487981b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/currencies/CurrencyEdit.vue"
export default component.exports